import { FC } from 'react';
import { Main } from '@components';

const EmptyPage: FC = () => {
  return <Main background='none'></Main>;
};

export default EmptyPage;
